<div *ngIf="tieneDeuda" class="card border-warning mb-3 deuda-adicional-card">
	<div class="card-body">
		<div class="d-flex flex-wrap justify-content-between align-items-start mb-3">
			<div class="mr-3">
				<h5 class="font-weight-bold text-dark mb-1">
					<i class="fas fa-exclamation-triangle text-warning mr-2"></i>
					Facturas pendientes por adicionales
				</h5>
				<p class="text-muted mb-0">
					Se detectaron {{ deuda.cantidadFacturas }} factura(s) pendiente(s) asociadas a adicionales o certificaciones.
				</p>
			</div>
		</div>

		<div class="table-responsive">
			<table class="table table-sm table-hover mb-0">
				<thead class="thead-light">
					<tr>
						<th>Referencia</th>
						<th>Tipo</th>
						<th>Fecha emisión</th>
						<th>Estado</th>
						<th class="text-center">Documento</th>
						<th class="text-right">Monto</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let factura of deuda.facturas">
						<td class="font-weight-bold">{{ factura.referencia }}</td>
						<td>{{ factura.tipo }}</td>
						<td>{{ factura.fechaEmision | date:'dd/MM/yyyy' }}</td>
						<td>
							<span class="badge" [ngClass]="factura.vencida ? 'badge-danger' : 'badge-warning'">
								{{ factura.vencida ? 'Vencida' : 'Pendiente' }}
							</span>
						</td>
						<td class="text-center">
							<button *ngIf="factura.facturaId" type="button" class="btn btn-icon btn-sm btn-danger"
									title="Ver factura" [disabled]="cargandoPdf" (click)="verFacturaPdf(factura.facturaId)">
								<i class="far fa-file-pdf text-white"></i>
							</button>
							<span *ngIf="!factura.facturaId" class="text-muted">—</span>
						</td>
						<td class="text-right font-weight-bold">$ {{ factura.total | number:'1.0-0':'es-CL' }}</td>
					</tr>
					<tr>
						<td colspan="5" class="text-right font-weight-bold">Total pendiente:</td>
						<td class="text-right font-weight-bold">$ {{ deuda.totalPendiente | number:'1.0-0':'es-CL' }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="d-flex flex-wrap justify-content-between align-items-center mt-3">
			<small class="text-muted mb-2 mb-md-0">
				{{ mensaje }}
			</small>
			<button
				type="button"
				class="btn btn-primary font-weight-bold"
				[disabled]="pagando"
				(click)="onPagar()">
				<span *ngIf="pagando" class="spinner-border spinner-border-sm mr-2"></span>
				Pagar deuda
			</button>
		</div>
	</div>
</div>
